import { Component, Input, OnInit, inject, DestroyRef } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { SidenavService } from 'src/app/services/util/sidenav.service';
import { Notification } from 'src/app/models/notification/notification';
import { NotificationsService } from 'src/app/services/api/notifications.service';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmationDialogComponent } from '../../confirmation-dialog/confirmation-dialog.component';
import { translate } from '@jsverse/transloco';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
    selector: 'app-notifications-list',
    templateUrl: './notifications-list.component.html',
    styleUrls: ['./notifications-list.component.scss'],
    standalone: false
})
export class NotificationsListComponent implements OnInit {
  @Input() title: string;
  sent: boolean;
  notifications: Notification[] = [];
  private destroyRef = inject(DestroyRef);
  constructor(public sidenavService: SidenavService, private formBuilder: FormBuilder,
    private notificationsService: NotificationsService, private matDialog: MatDialog) {
  }

  ngOnInit(): void {
    this.notifications = this.notificationsService.getNotifications();
  }

  markAsRead(notification: Notification): void {
    if(!notification.state.read) {
      this.notificationsService.markAsRead(notification.id)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe();
    }
  }

  openClearAllModal(): void {
    this.matDialog.open(ConfirmationDialogComponent, {
      panelClass: 'default-dialog-wrapper',
      width: '566px',
      autoFocus: false,
      data: {
        title: translate('NOTIFICATIONS.TITLE'),
        message: translate('NOTIFICATIONS.MESSAGE'),
        confirmButtonText: translate('BUTTONS.CLEAR')
      }
    })
      .afterClosed()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(confirm => {
        if (confirm) {
          const notificationIds = this.notifications.map(notification => notification.id);
          this.notificationsService.markAsDismissed(notificationIds)
          .pipe(takeUntilDestroyed(this.destroyRef))
          .subscribe(() => {
              this.notifications = this.notificationsService.getNotifications();
          });
        }
      });
  }

  onClearNotification(notification: Notification, notificationIndex: number): void {
    this.notificationsService.markAsDismissed([notification.id])
    .pipe(takeUntilDestroyed(this.destroyRef))
    .subscribe( () => {
      this.notifications = this.notificationsService.getNotifications();
    });
  }

}
